const initialState = {
    list: {},
    error: {}
};

const TagTreatmentReducer = (state, action) => {
    if (state === null || state === undefined) {
        state = initialState;
    }
    switch (action.type) {
        case "GET_TAG_TREATMENT_SUCCESS":
            state = {
                ...state,
                list: action.payload
            };

            return state;
        case "GET_TAG_TREATMENT_ERROR":
            state = {
                ...state,
                error: action.payload
            };
            return state;
        default:
            return state;
    }
};

export default TagTreatmentReducer;
